module.exports = __webpack_public_path__ + "img/img1.feb233be.jpg";